<template>

        <v-dialog
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            width="500"
        >
        <template v-slot:activator="{ on, attrs }">
            <a v-bind="attrs" v-on="on">

            <v-list-item
                color="red lighten-2"
                dark
            >
            <i class="mdi mdi-checkbox-blank"></i>

                <v-list-item-title>
                    {{translations.settings.title}}
                </v-list-item-title>
            </v-list-item>
            </a>


        </template>

        <v-card>
                <v-toolbar
                dark
                color="primary"
                >
                    <v-btn
                        icon
                        dark
                        @click="goBack()"
                    >
                        <v-icon>mdi-close</v-icon>

                        <span class="sr-only">{{translations.settings.close}}</span>

                    </v-btn>

                    <v-toolbar-title>{{translations.settings.title}}</v-toolbar-title>

                    <v-spacer></v-spacer>
                </v-toolbar>
            <v-list-item style="flex-direction: column; width: 100%; padding-top: 30px; flex-flow: wrap;">


                <v-list-item-title >

                    <label class="d-block" for='fonts' id="languageSelect">{{translations.settings.changedefault}}</label>

                </v-list-item-title >

                <v-switch
                    v-model="openDyslexic"
                    name="fonts"
                    class="d-block w-100"
                    width="100%"
                    :label="`OpenDyslexic`"
                    @change="updateFont(openDyslexic)"
                    solo
                    aria-labelledby="languageSelect"

                ></v-switch>

            </v-list-item>
            <v-list-item style="flex-direction: column; width: 100%; padding-top: 10px; flex-flow: wrap;">


                <v-list-item-title >
                    <label style="" for='langs' id="languageSelect">{{translations.settings.languages}}</label>

                </v-list-item-title>

                <v-select
                    v-model="selectedLang"
                    :items="langs"
                    style="padding-top: 10px;"
                    menu-props="auto"
                    name="langs"
                    prepend-icon-color="primary"
                    item-text="name"
                    item-value="code"
                    @change="updateLang(selectedLang)"
                    solo
                    id="langs"

                    >

                </v-select>
            </v-list-item>
            <v-alert
                close-text="Close Alert"
                color="#dee0e2"
                rounded="false"
                dismissible
                icon="mdi-alert-circle"
                class="banner"
                light
                @input="DismissFontAlert()"
                v-if="fontAlert"
            >

                <span v-if="openDyslexic">{{translations.settings.textopen}}</span>
                <span v-else>{{translations.settings.textdefault}}</span>

            </v-alert>
            <v-alert
                close-text="Close Alert"
                color="#dee0e2"
                rounded="false"
                dismissible
                icon="mdi-alert-circle"
                class="banner"
                light
                @input="DismissAlert()"
                v-if="alert"
            >
                {{translations.settings.languageset}} {{currentLang}}

            </v-alert>
        </v-card>
        </v-dialog>

</template>

<script>
// import hubbdata from "@/hubbdata";

export default {
    name: 'Settings',
    data() {
        return {
            selectedLang: localStorage.getItem('current_lang'),
            dialog: true,
            fontAlert: false,
            alert: false,
            openDyslexic: false,
            langs: [
                    { 'name': 'English', 'code': 'en' },
                    { 'name': 'Albanian | Shqiptare', 'code': 'sq'},
                    { 'name': 'Amharic | አማርኛ', 'code': 'am' },
                    { 'name': 'Arabic | عربي', 'code': 'ar' },
                    { 'name': 'Bengali | বাংলা', 'code': 'bn' },
                    { 'name': 'Chinese | 中国人', 'code': 'zh' },
                    { 'name': 'French | Français', 'code': 'fr' },
                    { 'name': 'Hindi | हिन्दी', 'code': 'hi' },
                    { 'name': 'Korean | 한국인', 'code': 'ko' },
                    { 'name': 'Kurdish-Kurmanji | Kurdî-Kurmancî', 'code': 'ku' },
                    { 'name': 'Pashto | میل', 'code': 'ps' },
                    { 'name': 'Persian | فارسی', 'code': 'fa' },
                    { 'name': 'Polish | Polski', 'code': 'pl' },
                    { 'name': 'Portugese | Português', 'code': 'pt' },
                    { 'name': 'Russian | Русский', 'code': 'ru' },
                    { 'name': 'Somali | Soomaali', 'code': 'so' },
                    { 'name': 'Spanish | Español', 'code': 'es' },
                    { 'name': 'Turkish | Türk', 'code': 'tr' },
                    { 'name': 'Ukrainian | український', 'code': 'uk' },
                    { 'name': 'Vietnamese | Tiếng Việt', 'code': 'vi' }
            ],
        }
    },

    mounted() {
        if (localStorage.getItem('enable_font_change') === "true" ) {
            this.openDyslexic = true
        }
        else {
            this.openDyslexic = false
        }
    },

    methods: {
        updateLang(selectedLang) {
            this.$store.dispatch("updateLang", selectedLang).then(() => {
                this.$store.dispatch("initDB").then(() => {
                this.$store.dispatch("getSurveys").then(() => {

                })});
            });
        },
        updateFont(font) {
            localStorage.setItem('enable_font_change', font)
            this.$store.dispatch("updateFont", font)
            this.fontAlert = true;

            if (localStorage.getItem('enable_font_change') == "true" ) {
              document.querySelector('#app').classList.add('open-dyslexic')
            } else {
              document.querySelector('#app').classList.remove('open-dyslexic')
            }
        },
        DismissAlert() {
            this.alert = false;
        },
        DismissFontAlert() {
            this.fontAlert = false;
        },
        goBack() {
            this.$router.go(-1);
        }
    },

    computed: {
        translations() {
            return this.$store.getters.translations;
        },
        currentLang() {
            let dictionary = {
                en: "English",
                sq: "Albanian",
                am: "Amharic",
                ar: "Arabic",
                bn: "Bengali",
                zh: "Chinese",
                fr: "French",
                hi: "Hindi",
                ko: "Korean",
                ku: "Kurdish-Kurmanji",
                ps: "Pashto",
                fa: "Persian",
                pl: "Polish",
                pt: "Portugese",
                ru: "Russian",
                so: "Somali",
                es: "Spanish",
                tr: "Turkish",
                uk: "Ukrainian",
                vi: "Vietnamese"
            }
            return dictionary[this.selectedLang];
        },
    }
}
</script>
